
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftLeft50 as ObiThreewayStackedInleftLeft50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-left-50.js';
 
 
 

 
 export const ObiThreewayStackedInleftLeft50 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-left-50',
   elementClass: ObiThreewayStackedInleftLeft50Element,
   events: {
     
   }
  });
 
 